<div *ngIf="!modal" class="container-fluid pl-0 pr-0">
  <div class=" p-3">
    <div class="row">
        <div class="col">
            <div class="row">
                <div class="col">
                    <p class="mb-0 fw-400 pb-2">{{org.organizationname}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="mb-0 pb-1">{{org.address}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="mb-0 pb-1">{{org.address2}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="mb-0 pb-1">{{org.city}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="mb-0 pb-1">{{org.zip}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="row">
                        <div class="col-auto pr-0">
                            <a class="cursor-pointer" href="{{org.www}}">
                                <span class="material-icons f-20 opacity lh-30 align-middle cursor-pointer text-muted">
                                    public
                                </span>
                            </a>
                        </div>
                        <div class="col-auto pl-1">    
                            <a class="cursor-pointer" href="{{org.www}}">
                                <p class="mb-0 pt-1 cursor-pointer opacity">{{org.www}}</p>
                            </a>   
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="float-right pr-3">
            </div>
        </div>
    </div>
    <div class="row mt-2 ">
        <div class="col">
            <p class="mb-0">{{org.orgdesc}}</p>
        </div>
    </div>
</div>
</div> 

<div *ngIf="modal">
  <div class="form-group mt-0 mb-2">
    <label for="orgname" class="font-weight-light f-13 mb-0">{{ 'orgedit.name' | trans }}</label>
    <input (keydown)="onChange()" [(ngModel)]="org.organizationname" type="text" class="form-control" id="orgname" aria-describedby="orgnameHelp">
    <small id="orgnameHelp" class="form-text text-muted">{{ 'orgedit.namehelp' | trans }}</small>
  </div>
  <div class="form-group mb-2">
    <label for="orgname" class="font-weight-light f-13 mb-0">{{ 'orgedit.email' | trans }}</label>
    <input (keydown)="onChange()" [(ngModel)]="org.email" type="text" class="form-control" id="orgname" aria-describedby="orgnameHelp">
    <small id="orgnameHelp" class="form-text text-muted">{{ 'orgedit.emailhelp' | trans }}</small>
  </div>
  <div class="form-group mb-2">
    <label for="phone" class="font-weight-light f-13 mb-0">{{ 'orgedit.phone' | trans }}</label>
    <input (keydown)="onChange()" [(ngModel)]="org.phone" type="text" class="form-control" id="phone" aria-describedby="phoneHelp">
    <small id="phoneHelp" class="form-text text-muted">{{ 'orgedit.phonehelp' | trans }}</small>
  </div>
  <div class="form-group mb-2">
    <label for="orgname" class="font-weight-light f-13 mb-0">{{ 'orgedit.website' | trans }}</label>
    <input (keydown)="onChange()" [(ngModel)]="org.www" type="text" class="form-control" id="orgname" aria-describedby="orgnameHelp">
    <small id="orgnameHelp" class="form-text text-muted">{{ 'orgedit.websitehelp' | trans }}</small>
  </div>
  <div class="form-group mb-2">
    <label for="orgname" class="font-weight-light f-13 mb-0">{{ 'orgedit.address' | trans }}</label>
    <input (keydown)="onChange()" [(ngModel)]="org.address" type="text" class="form-control" id="orgname" aria-describedby="orgnameHelp">
    <small id="orgnameHelp" class="form-text text-muted">{{ 'orgedit.addresshelp' | trans }}</small>
  </div>
  <div class="form-group mb-2">
    <label for="orgname" class="font-weight-light f-13 mb-0">{{ 'orgedit.address2' | trans }}</label>
    <input (keydown)="onChange()" [(ngModel)]="org.address2" type="text" class="form-control" id="orgname" aria-describedby="orgnameHelp">
    <small id="orgnameHelp" class="form-text text-muted">{{ 'orgedit.address2help' | trans }}</small>
  </div>
  <div class="row">
    <div class="col">
      <div class="form-group mb-2">
        <label for="orgname" class="font-weight-light f-13 mb-0">{{ 'orgedit.zip' | trans }}</label>
        <input (keydown)="onChange()"  [(ngModel)]="org.zip" type="text" class="form-control" id="orgname" aria-describedby="orgnameHelp">
        <small id="orgnameHelp" class="form-text text-muted">{{ 'orgedit.ziphelp' | trans }}</small>
      </div>
    </div>
    <div class="col">
      <div class="form-group mb-2">
        <label for="orgname" class="font-weight-light f-13 mb-0">{{ 'orgedit.country' | trans }}</label>
        <input (keydown)="onChange()" [(ngModel)]="org.country" type="text" class="form-control" id="orgname" aria-describedby="orgnameHelp">
        <small id="orgnameHelp" class="form-text text-muted">{{ 'orgedit.countryhelp' | trans }}</small>
      </div>
    </div>
  </div>
  <div class="form-group mb-0">
    <label for="description" class="font-weight-light f-13 mb-0">{{ 'orgedit.description' | trans }}</label>
    <textarea  (keydown)="onChange()" class="form-control" id="description" rows="3" aria-describedby="descriptionHelp" [(ngModel)]="org.orgdesc" ></textarea>
    <small id="descriptionHelp" class="form-text text-muted">{{ 'orgedit.descriptionhelp' | trans }}</small>
  </div>
  <div *ngIf="et_admin" class="form-group mb-0">
    <label for="orgName" class="font-weight-light f-13 mb-0">{{ 'orgedit.clearrampmodules' | trans }}</label>
    <input (keydown)="onChange()" type="text" class="form-control" id="modules" name="modules" [(ngModel)]="org.modules"/>  
    <small id="modulesHelp" class="form-text text-muted">{{ 'orgedit.clearrampmoduleshelp' | trans }} projects, planning, portal, whitelabel, hubspot</small>
  </div>
  <p class="cursor-default mb-1 f-13 text-muted">{{editstate}}</p>
</div>





